import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { getJwtRoleSlug } from "../../../public/utils/jwtRole";
import { getStoredAuthRole } from "../../../public/utils/authSession";
import { useScheduleRolePermissions } from "../hooks/useScheduleRolePermissions";
import {
  buildSchedulePermissions,
  buildSchedulePermissionsForScreen,
} from "./schedulePermissions";

function resolveRoleSlug() {
  if (typeof localStorage === "undefined") return "";
  return (
    getJwtRoleSlug(localStorage.getItem("jwt_token")) ||
    getStoredAuthRole() ||
    ""
  );
}

/** Current JWT role + schedule permissions from User builder (optional screen slug). */
export function useScheduleRole(screenSlug = null) {
  const location = useLocation();
  const sessionRoleSlug = useMemo(() => resolveRoleSlug(), [location.pathname]);

  const {
    permissions,
    roleSlug: apiRoleSlug,
    loading: permLoading,
    error: permissionsError,
  } = useScheduleRolePermissions(Boolean(sessionRoleSlug));

  const roleSlug = apiRoleSlug || sessionRoleSlug;

  const perms = useMemo(() => {
    if (screenSlug) {
      return buildSchedulePermissionsForScreen(permissions, roleSlug, screenSlug);
    }
    return buildSchedulePermissions(permissions, roleSlug);
  }, [permissions, roleSlug, screenSlug]);

  return {
    roleSlug,
    permissionsLoading: permLoading,
    permissionsError,
    isAdmin: perms.isAdmin,
    isOffice: perms.isOffice,
    isOfficePanel: perms.isOffice && (perms.canView || perms.canCreate),
    canView: perms.canView,
    canCreate: perms.canCreate,
    canEdit: perms.canEdit,
    canDelete: perms.canDelete,
    canComplete: perms.canComplete,
    canCancel: perms.canCancel,
    canManageMasters: perms.canManageMasters,
    canDeleteMasters: perms.canDeleteMasters,
    canExport: perms.canExport,
  };
}
